module.exports = __webpack_public_path__ + "img/yy-s9.81bd7df8.svg";